import { memo } from 'react';
import clsx from 'clsx';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import {
    PopularSearches,
    RecentSearches,
    SEARCH_MENU_ID,
    SearchSuggestionsContainer,
    VipBrandsValue,
} from '../../../../../../../src';
import { useSearchActionContext, useSearchStateContext } from '../provider';
import { CloseMenu } from './CloseMenu';

export type SearchMenuProps = PropsWithLocale & {
    vipBrands: VipBrandsValue;
};

export const SearchMenu: ComponentMemo<SearchMenuProps> = memo(({ vipBrands, locale }) => {
    'use memo';

    const { isSearchOpen, searchInput } = useSearchStateContext();
    const { handleClose, onSearch } = useSearchActionContext();

    if (!isSearchOpen) {
        return null;
    }

    return (
        <div className={'absolute w-fullViewport left-0'}>
            <div id={SEARCH_MENU_ID} className={clsx('w-full', 'bg-background-l0', 'flex justify-center items-center')}>
                <div
                    className={clsx(
                        'flex flex-col tablet:flex-row flex-1 desktop:gap-2.5',
                        'px-1 desktopS:px-2.5 py-2',
                        'max-w-largestDesktop',
                        'h-full',
                    )}
                >
                    <div className={clsx('flex flex-col flex-1 gap-2.5', 'desktop:flex-row')}>
                        {searchInput ? (
                            <SearchSuggestionsContainer
                                searchInput={searchInput}
                                onSearch={onSearch}
                                vipBrands={vipBrands}
                            />
                        ) : (
                            <>
                                <PopularSearches />
                                <RecentSearches locale={locale} />
                            </>
                        )}
                    </div>
                    <CloseMenu
                        className={'close-search-menu hidden tablet:flex !justify-end self-start text-text-primary'}
                    />
                </div>
            </div>
            <div
                role={'button'}
                aria-hidden
                onClick={handleClose}
                className={'h-fullViewport bg-background-overlay hidden tablet:block'}
            />
        </div>
    );
});

SearchMenu.displayName = 'SearchMenu';
